export default {
  title: "Privacy Policy",
  subtitle: "We value your privacy and are committed to protecting your personal information",
  lastUpdated: "Last updated: January 15, 2024",
  intro: "Deriway (\"we\", \"company\") respects and protects users' privacy rights. This privacy policy explains how we collect, use, store and protect your personal information.",
  
  section1: {
    title: "1. Information Collection",
    personalInfo: "Personal Identity Information: Name, email address, phone number, ID documents, etc.",
    transactionInfo: "Transaction Information: Payment records, transaction history, account balance, etc.",
    technicalInfo: "Technical Information: IP address, device information, browser type, operating system, etc.",
    usageInfo: "Usage Information: Service usage records, preference settings, operation logs, etc."
  },
  
  section2: {
    title: "2. Information Use",
    item1: "• Provide and improve our financial services",
    item2: "• Verify user identity, prevent fraud and money laundering",
    item3: "• Process transactions and payment requests",
    item4: "• Send important notifications and service updates",
    item5: "• Comply with laws, regulations and regulatory requirements",
    item6: "• Conduct risk assessment and compliance review"
  },
  
  section3: {
    title: "3. Information Sharing",
    intro: "We do not sell, rent or trade your personal information. We only share in the following circumstances:",
    item1: "• With your explicit consent",
    item2: "• Required by laws, regulations or government departments",
    item3: "• Cooperation with trusted third-party service providers (such as payment processors)",
    item4: "• Protecting our legitimate interests or preventing fraud"
  },
  
  section4: {
    title: "4. Data Security",
    item1: "• Use industry-standard encryption technology to protect data transmission",
    item2: "• Implement strict access control and permission management",
    item3: "• Regularly conduct security audits and vulnerability scans",
    item4: "• Comply with security standards such as PCI DSS",
    item5: "• Establish comprehensive data backup and recovery mechanisms"
  },
  
  section5: {
    title: "5. Your Rights",
    accessRight: "• Right of Access: View your personal information we hold",
    correctionRight: "• Right of Rectification: Request correction of inaccurate personal information",
    deletionRight: "• Right of Erasure: Request deletion of personal information in specific circumstances",
    restrictionRight: "• Right to Restrict Processing: Restrict our processing of your personal information",
    portabilityRight: "• Right to Data Portability: Obtain your data in a structured format"
  },
  
  section6: {
    title: "6. Cookie Policy",
    intro: "We use cookies and similar technologies to:",
    item1: "• Remember your login status and preference settings",
    item2: "• Analyze website usage and improve user experience",
    item3: "• Provide personalized content and advertisements",
    item4: "• Ensure website security and prevent fraud"
  },
  
  section7: {
    title: "7. Data Retention",
    intro: "We only retain your personal information for the necessary period:",
    item1: "• Period required to provide services",
    item2: "• Retention period required by laws and regulations",
    item3: "• Period required to resolve disputes and enforce agreements",
    item4: "• Period to meet regulatory requirements"
  },
  
  section8: {
    title: "8. International Data Transfer",
    intro: "Your personal information may be transferred to locations outside your country/region for processing. We will:",
    item1: "• Ensure recipients provide adequate data protection",
    item2: "• Sign standard contractual clauses or other legal mechanisms",
    item3: "• Comply with applicable data protection laws"
  },
  
  section9: {
    title: "9. Policy Updates",
    intro: "We may update this privacy policy from time to time. For significant changes, we will:",
    item1: "• Post update notices on the website",
    item2: "• Notify you via email or other means",
    item3: "• Obtain your consent when required by law"
  },
  
  section10: {
    title: "10. Contact Us",
    intro: "If you have any questions about this privacy policy or need to exercise your rights, please contact us:",
    email: "• Email: support@deriway.com",
    telegram: "• Telegram: @deriway_business",
    response: "• We will respond promptly after receiving your request"
  }
};